import * as React from 'react';

const useNavBarPosition = () => {
  const [isOnTop, setIsOnTop] = React.useState(true);

  const onScroll = React.useCallback(() => {
    const isTop = window.scrollY < 25;
    setIsOnTop(isTop);
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll, {
      passive: true,
      capture: true,
    });
    window.onload = onScroll;

    onScroll();

    return function cleanup() {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  return isOnTop;
};

export default useNavBarPosition;
